import { DateTime } from 'luxon';

export function createWhenString(departureTime: DateTime | undefined, arrivalTime: DateTime | undefined): string {
  if (!departureTime || !arrivalTime) {
    return '';
  }

  const from = departureTime;
  const to = arrivalTime;

  let result: string;
  if (from.hasSame(to, 'day')) {
    result = `${from.toFormat('EEEE dd MMMM yyyy  HH:mm')}-${to.toFormat('HH:mm')}`;
  } else {
    result = `${from.toFormat('EEEE dd MMMM yyyy  HH:mm')}  -  ${to.toFormat('EEEE dd MMMM yyyy  HH:mm')}`;
  }
  return `${result.substring(0, 1).toUpperCase()}${result.substring(1)}`;
}
